import * as React from 'react'
import { useState } from 'react'
import { SelectProps } from './types'
import { StyledErrorMessage, StyledSelect, StyledLabel } from './styled'

export const Select = ({
  children,
  variant = 'default',
  error = undefined,
  value,
  onChange,
  label,
  ...rest
}: SelectProps) => {
  return (
    <>
      <StyledLabel variant={variant} showPlaceholder={!value} hasError={!!error}>
        <StyledSelect defaultValue="" {...rest} onChange={onChange} value={value}>
          <option hidden disabled value="" label=" ">
            {' '}
          </option>
          {children}
        </StyledSelect>
        <span>{label}</span>
      </StyledLabel>
      {error && <StyledErrorMessage>{error}</StyledErrorMessage>}
    </>
  )
}
